import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border border-slate-200 bg-slate-50/70 px-4 py-3"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-start justify-between gap-3"
};
const _hoisted_3 = {
  key: 0,
  class: "inline-flex items-center rounded-md bg-amber-50 px-2 py-1 text-xs font-medium text-amber-700"
};
const _hoisted_4 = {
  key: 0,
  class: "mt-3 space-y-3"
};
const _hoisted_5 = {
  class: "flex flex-wrap items-start justify-between gap-3 rounded-md bg-white px-3 py-3 ring-1 ring-slate-200"
};
const _hoisted_6 = {
  class: "flex min-w-0 items-center gap-2"
};
const _hoisted_7 = {
  class: "flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-100 text-xs font-medium text-slate-600"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "min-w-0"
};
const _hoisted_11 = {
  class: "truncate text-sm font-medium text-slate-800"
};
const _hoisted_12 = {
  class: "text-xs text-slate-400"
};
const _hoisted_13 = {
  class: "flex shrink-0 items-center gap-2",
  "aria-label": "评价星级"
};
const _hoisted_14 = {
  class: "flex items-center gap-0.5"
};
const _hoisted_15 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_16 = {
  class: "whitespace-pre-wrap break-words text-sm leading-6 text-slate-600"
};
const _hoisted_17 = {
  key: 1,
  class: "mt-3 rounded-md border border-dashed border-slate-200 bg-white px-3 py-4 text-sm text-slate-400"
};
import { computed } from 'vue';
import { StarIcon } from '@heroicons/vue/24/solid';
export default {
  __name: 'ReportEvaluationSummary',
  props: {
    evaluations: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const gradeLabels = {
      EXCELLENT: '优秀',
      GOOD: '良好',
      MEETS_EXPECTATIONS: '符合要求',
      NEEDS_IMPROVEMENT: '有待改进',
      UNQUALIFIED: '不合格'
    };
    const gradeScores = {
      EXCELLENT: 5,
      GOOD: 4,
      MEETS_EXPECTATIONS: 3,
      NEEDS_IMPROVEMENT: 2,
      UNQUALIFIED: 1
    };
    const currentEvaluation = computed(() => {
      const evaluations = Array.isArray(props.evaluations) ? props.evaluations : [];
      return evaluations.find(evaluation => evaluation.current && evaluation.phase === 'SUMMARY') || null;
    });
    function gradeLabel(grade) {
      return gradeLabels[grade] || '已评价';
    }
    function gradeScore(grade) {
      return gradeScores[grade] || 0;
    }
    function evaluatorName(evaluation) {
      return evaluation?.evaluatorName || evaluation?.evaluatorDisplayName || evaluation?.evaluatorUserName || evaluation?.evaluator?.displayName || evaluation?.evaluator?.name || evaluation?.evaluator?.realName || evaluation?.evaluator?.username || (evaluation?.evaluatorUserId ? `用户 ${evaluation.evaluatorUserId}` : '未署名');
    }
    function evaluatorAvatarUrl(evaluation) {
      return evaluation?.evaluatorAvatarUrl || evaluation?.evaluatorAvatarURL || evaluation?.avatarUrl || evaluation?.evaluator?.avatarUrl || evaluation?.evaluator?.avatarURL || evaluation?.evaluatorAvatar || evaluation?.avatar || evaluation?.evaluator?.avatar || '';
    }
    function initials(evaluation) {
      const name = evaluatorName(evaluation);
      if (name === '未署名') return '?';
      return name.slice(0, 2).toUpperCase();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", null, [_createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-900"
      }, "评价结果"), _createElementVNode("p", {
        class: "mt-0.5 text-xs text-slate-500"
      }, "总结提交后的正式评价")], -1)), currentEvaluation.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(gradeLabel(currentEvaluation.value.grade)), 1)) : _createCommentVNode("", true)]), currentEvaluation.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [evaluatorAvatarUrl(currentEvaluation.value) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: evaluatorAvatarUrl(currentEvaluation.value),
        alt: `${evaluatorName(currentEvaluation.value)}头像`,
        class: "h-full w-full object-cover"
      }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(initials(currentEvaluation.value)), 1))]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, _toDisplayString(evaluatorName(currentEvaluation.value)), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(currentEvaluation.value.evaluatedAt || '--'), 1)])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, score => {
        return _createVNode(_unref(StarIcon), {
          key: score,
          class: _normalizeClass(["h-4 w-4", score <= gradeScore(currentEvaluation.value.grade) ? 'text-amber-400' : 'text-slate-200']),
          "aria-hidden": "true"
        }, null, 8, ["class"]);
      }), 64))]), _createElementVNode("span", _hoisted_15, _toDisplayString(gradeScore(currentEvaluation.value.grade) || '-') + "/5", 1)])]), _createElementVNode("p", _hoisted_16, _toDisplayString(currentEvaluation.value.comment || '暂无评价意见'), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_17, " 暂无评价 "))]);
    };
  }
};